const colors = {
  main: '#8cb38d',
  border: '#d2cfcf',
  gray: '#979797',
  grayBg: '#f6f6f6',
  orange: '#feaf6d',
  noti: '#646464',
  black: '#000',
  white: '#fff',
};

const transition = {
  default: '.3s ease',
};

const customMediaQuery = (maxWidth: number): string => {
  return `@media (max-width: ${maxWidth}px)`;
};

const media = {
  desktop: customMediaQuery(1200),
  mobile: customMediaQuery(767),
};

const font = {
  noti: '18px',
  title: '22px',
  subTitle: '16px',
  check: '15px',
};

export const theme = {
  colors,
  transition,
  font,
  media,
};

export type ThemeType = typeof theme;
